import Badge from 'components/UI/Badge/Badge';
import { FC } from 'react';

export interface Creator {
  companyName: string;
  contactName: string;
  description: string;
  email: string;
  link: string;
  type: string;
}

const CreatorsListItem: FC<Creator> = ({
  companyName,
  contactName,
  description,
  email,
  link,
  type,
}) => {
  return (
    <section className="flex flex-col mt-4 pb-6 border-b border-slate-300">
      <div className="mb-1 flex flex-col-reverse gap-1">
        <h2 className="text-3xl font-semibold text-slate-900">{companyName}</h2>
        <Badge
          name={type}
          color="red"
          className="text-sm font-medium leading-4 w-fit"
        />
      </div>

      <div className="prose lg:prose-lg">
        <blockquote>
          <p>{description}</p>
        </blockquote>
      </div>

      <div className="text-base font-medium text-black">
        <p>
          <span>Contact:</span> {contactName}
        </p>

        <p>
          <a href={`mailto:${email}`}>
            <span>Email:</span> {email}
          </a>
        </p>

        <a href={link} target="_blank" rel="noopener noreferrer">
          <span>Website:</span> {link}
        </a>
      </div>
    </section>
  );
};

export default CreatorsListItem;
